/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {EmptyableConfig} from "./EmptyableConfig";
import {UiTabConfig} from "./UiTabConfig";
import {UiToolButtonConfig} from "./UiToolButtonConfig";
import {UiItemViewConfig} from "./UiItemViewConfig";
import {UiToolbarConfig} from "./UiToolbarConfig";
import {UiTabPanelTabStyle} from "./UiTabPanelTabStyle";


export interface UiTabPanelConfig extends UiComponentConfig, EmptyableConfig {
	_type?: string;
	tabs?: UiTabConfig[];
	selectedTabId?: string;
	hideTabBarIfSingleTab?: boolean;
	tabStyle?: UiTabPanelTabStyle;
	toolButtons?: UiToolButtonConfig[]
}

export interface UiTabPanelCommandHandler {
	setHideTabBarIfSingleTab(hideTabBarIfSingleTab: boolean): void;
	setTabStyle(tabStyle: UiTabPanelTabStyle): void;
	setToolButtons(toolButtons: UiToolButtonConfig[]): void;
	selectTab(tabId: string, sendSelectionEvent: boolean): void;
	addTab(tab: UiTabConfig, select: boolean, sendSelectionEvent: boolean): void;
	removeTab(tabId: string): void;
	showToolButtonDropDown(toolButtonId: string, dropDownItemView: UiItemViewConfig, dropDownWidth: number): void;
	setTabToolbar(tabId: string, toolbar: UiToolbarConfig): void;
	setTabContent(tabId: string, component: UiComponentConfig): void;
	setTabConfiguration(tabId: string, icon: string, caption: string, closeable: boolean, rightSide: boolean): void;
}

export interface UiTabPanelEventSource {
	onTabSelected: TeamAppsEvent<UiTabPanel_TabSelectedEvent>;
	onTabNeedsRefresh: TeamAppsEvent<UiTabPanel_TabNeedsRefreshEvent>;
	onTabClosed: TeamAppsEvent<UiTabPanel_TabClosedEvent>;
	onToolButtonClicked: TeamAppsEvent<UiTabPanel_ToolButtonClickedEvent>;
	onToolButtonDropDownItemClicked: TeamAppsEvent<UiTabPanel_ToolButtonDropDownItemClickedEvent>;
}

export interface UiTabPanel_TabSelectedEvent extends UiEvent {
	_type: "UiTabPanel.tabSelected";
	redundancyKey?: string;
	tabId: string
}

export interface UiTabPanel_TabNeedsRefreshEvent extends UiEvent {
	_type: "UiTabPanel.tabNeedsRefresh";
	redundancyKey?: string;
	tabId: string
}

export interface UiTabPanel_TabClosedEvent extends UiEvent {
	_type: "UiTabPanel.tabClosed";
	redundancyKey?: string;
	tabId: string
}

export interface UiTabPanel_ToolButtonClickedEvent extends UiEvent {
	_type: "UiTabPanel.toolButtonClicked";
	redundancyKey?: string;
	toolButtonId: string
}

export interface UiTabPanel_ToolButtonDropDownItemClickedEvent extends UiEvent {
	_type: "UiTabPanel.toolButtonDropDownItemClicked";
	redundancyKey?: string;
	toolButtonId: string;
	itemId: any
}

